module.exports = __webpack_public_path__ + "static/panoroom_unique_measurement-e8b111141894073060d2454b7946a2d8.mp4";